module.exports = __webpack_public_path__ + "static/media/calefont40.00ae49a7.png";